export const PACKAGE_MODEL_NAME = {
  1: 'packageOneModel',
  2: 'packageTwoModel',
  3: 'packageThreeModel',
  4: 'packageFourModel',
};
